import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Typography } from '@mui/material';
import { NAV_RAIL_WIDTH } from './constants';

// The labels under the rail icons. Sizing lives on the tooltip itself and the
// lines inherit it, so there is one number to change - Typography's own body1
// size (16px) used to win here, which is how "Management" grew to 96px and
// painted ~13px of itself over the pane next to a 90px rail.
const labelSx = {
    textAlign: 'center',
    cursor: 'pointer',
    fontSize: 'inherit',
};

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props} classes={{ popper: className }}
        title={
            <React.Fragment
            >
                <Typography color="inherit"
                    onClick={props.onClick}
                    sx={labelSx}
                >
                    {props.title}</Typography>
                {props.title2 &&
                    <Typography color="inherit"
                        onClick={props.onClick}
                        sx={labelSx}>
                        {props.title2}
                    </Typography>}
            </React.Fragment>
        }
        sx={{
            ...props.sx,
            paddingTop: '15px',
            paddingBottom: '20px',
            cursor: 'pointer',
            zIndex: 1
        }}
        slotProps={props.slotProps || {
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -25],
                        },
                    },
                ],
                sx: {
                    padding: 0,
                    zIndex: 0
                }
            },
        }}
    />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        background: 'transparent',
        color: 'rgb(22, 123, 195)',
        boxShadow: '',
        // Every current label fits on one line at 14px inside the rail, the
        // longest ("Management") with ~6px to spare. The cap is what makes that
        // hold for labels nobody has written yet: a longer one wraps to a second
        // line instead of spilling out of the rail.
        fontSize: 14,
        maxWidth: NAV_RAIL_WIDTH,
        overflowWrap: 'anywhere',
        // Horizontal padding only would eat into the cap above; the vertical
        // padding is MUI's default and is what keeps the label off the icon.
        padding: '4px 0',
        margin: '0 !important',
    },
}));

export default LightTooltip
